import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    enabled: translate({ id: 'global.enabled' }),
    disabled: translate({ id: 'global.disabled' }),
    label: translate({ id: 'vehicles.form.driverBehaviors.postedSpeedLimit.noTolerance' }),
    tolerance: translate({ id: 'vehicles.form.driverBehaviors.tolerance' }),
    unitOfMeasure: (label: string, metric: boolean) => {
      const uom = translate({
        id: metric ? 'global.unitOfMeasure.kmh' : 'global.unitOfMeasure.mph',
      })
      return `${label} (${uom})`
    },
  }))

  return api
}
